/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */

import React, {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faGithub, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup, FormControl } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../../routes";
import BgImage from "../../assets/img/illustrations/signin.svg";
import { GetResultObject, PostRequest } from "../../core/API";
import axios from "axios";
import { ApiSrc } from "../../resources/ApiSrc";
import AppConfig from "../../core/config/AppConfig"
import {storeToken, storeUserInfo} from "../../core/auth/authentication"
import _ from "lodash";
import { jnDecrypt, jnEncrypt } from "../../core/util/General";
import bg_image from '../../assets/background/login_bg.jpg';
export default () => {

  const [password, setPassword] = useState()
  const [username, setUsername] = useState()
  const [message, setMessage] = useState()

  const login = () => {
    console.log(username, password)
    try {
      var bodyFormData = new FormData();
      bodyFormData.append("username", username);
      bodyFormData.append("password", password);
      bodyFormData.append("grant_type", "password");
      axios({
        method: "post",
        url: ApiSrc.LOGIN,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
          "Accept": "application/json",
          "Content-Type": "multipart/form-data",          
          "Authorization": `${AppConfig.basic_key}`,
        },
        data: bodyFormData,
      })
        .then((result) => {
          //console.log(">> result", result)
          if(_.get(result, 'data.access_token')){            
            const token = _.get(result, 'data.access_token');
            console.log(">> token", token)
            storeToken(token)
            PostRequest(ApiSrc.GET_USER_INFO, {}, {}).then(result1 => {
              console.log(">> result1", result1)
              GetResultObject(result1, 'data', 200, (data1, page) => {
                jnEncrypt(data1).then((value) => {
                  storeUserInfo(value)
                });                
              })    
            })                        
            // window.location.reload();
          }else {
            setMessage("Login failed")
          }   
        })
        .catch((error) => {
          setMessage("Login failed")
          console.log(">error:", error);      
        });
      // return response;
    } catch (error) {
      setMessage("Login failed")
      console.log(">axios error:", error);      
    }
  }

  return (
    <main style={{ backgroundImage: `url(${bg_image})`, height: '100vh', backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', }}>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          {/* <p className="text-center">
            <Card.Link as={Link} to={Routes.DashboardOverview.path} className="text-gray-700">
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to homepage
            </Card.Link>
          </p> */}
          <Row className="justify-content-center form-bg-image">
          {/* <Row className="justify-content-center form-bg-image" > */}
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">GLOBAL HUB</h3>
                </div>
                                  
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Username</Form.Label>
                    <InputGroup>
                      <InputGroup.Text >
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control autoFocus required type="text" 
                        onChange={(e)=>setUsername(e.target.value)} 
                        placeholder="example@joonaak.com" />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Your Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text onChange={(e)=>setPassword(e.target.value)}>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control required type="password" placeholder="Password" 
                          onChange={(e)=>setPassword(e.target.value)}/>
                      </InputGroup>
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Form.Check type="checkbox">
                        <FormCheck.Input id="defaultCheck5" className="me-2" />
                        <FormCheck.Label htmlFor="defaultCheck5" className="mb-0">Remember me</FormCheck.Label>
                      </Form.Check>
                      <Card.Link className="small text-end text-danger">{message ?? ''}</Card.Link>
                    </div>
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100" onClick={login}>
                    Sign in
                  </Button>                                         
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
